<template>
    <div>
      <div class="white-background list-top-margin">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>生产管理</el-breadcrumb-item>
            <el-breadcrumb-item><span @click="goBack" style="cursor:pointer;">销售订单</span></el-breadcrumb-item>
            <el-breadcrumb-item>
              <span style="color:#000;font-weight:bold;" v-if="mode == 'create'">创建销售订单</span>
              <span style="color:#000;font-weight:bold;" v-if="mode != 'create'">编辑销售订单</span>
            </el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <el-divider></el-divider> -->
        <el-form ref="orderForm" :model="orderForm" :rules="orderFormRule" label-width="100px" class="order-form">
            <el-row :gutter="5">
                <el-col :span="8">
                    <el-form-item label="销售订单编号">
                        <el-input size="small" v-model="orderForm.salesOrderCode" placeholder="输入销售订单编号，忽略将自动生成" :disabled="mode != 'create'"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="合同编号" prop="contractCode">
                        <el-input size="small" v-model="orderForm.contractCode" placeholder="输入合同编号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="客户名称" prop="customerName">
                        <el-input size="small" v-model="orderForm.customerName" placeholder="输入客户名称"></el-input>
                    </el-form-item>
                </el-col>

            </el-row>
        </el-form>
      </div>
      <div class="white-background">
        <el-row class="tbl-btn">
            <el-col :span="12" class="tbl-btn-left">
                <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="addProduct" v-if="mode == 'create'">添加产品</el-button>
                <!-- <el-button type="primary" size="small" icon="el-icon-download" plain>导入数据</el-button> -->
            </el-col>
            <!-- <el-col :span="12" class="tbl-btn-right">
                <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
            </el-col> -->
        </el-row>
        <!--列表-->
        <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        stripe
        border
        element-loading-text="加载中"
        :header-cell-style="_headerStyle"
        style="width: 100%;"
        row-key="_id"
        >
        <el-table-column align="left" type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column   label="产品编号" >
            <template slot-scope="scope">
            <el-tooltip :content="scope.row.productCode" placement="top">
                <span class="txt-overflow" >{{scope.row.productCode}}</span>
            </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column  label="产品名称" >
            <template slot-scope="scope">
            <el-tooltip :content="scope.row.productName" placement="top">
                <span class="txt-overflow">{{scope.row.productName}}</span>
            </el-tooltip>
            </template>
        </el-table-column>

        <el-table-column  label="产品规格" >
            <template slot-scope="scope">
            <el-tooltip :content="scope.row.specs" placement="top">
                <span class="txt-overflow">{{scope.row.specs}}</span>
            </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column  prop="source" label="产品属性"  width="150">
        </el-table-column>
        <el-table-column  prop="unit" label="单位" width="90">
        </el-table-column>

        <el-table-column   prop="planNum" label="计划数" width="200">
          <template slot-scope="scope">
            <el-input-number
            size="mini"
              class="input-number"
              style="width: 100%;"
              v-model="planNum"
              controls-position="right"
              :min="1"
              placeholder="请填写"
              v-if="scope.row.isEnable"
            ></el-input-number>
            <span v-if="!scope.row.isEnable" :title="scope.row.planNum">{{scope.row.planNum}}</span>
          </template>

        </el-table-column>
        <el-table-column   prop="planTime" label="计划时间" width="300">
          <template slot-scope="scope">
              <el-date-picker
              size="mini"
                popper-class="order-create-picker"
                style="width: 100%;"
                :clearable="false"
                v-model="planTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                v-if="scope.row.isEnable"
                >
              </el-date-picker>
              <span v-if="!scope.row.isEnable && scope.row.planStartTime">{{scope.row.planStartTime + '~' +scope.row.planEndTime }}</span>
          </template>


        </el-table-column>


        <el-table-column align="left"  label="操作" width="150">
            <template slot-scope="scope">
              <el-tooltip content="保存" v-if="scope.row.isEnable">
                <el-button type="success" size="mini" icon="el-icon-check" circle @click="handleSave(scope.$index, scope.row)"></el-button>

              </el-tooltip>
              <el-tooltip content="取消" v-if="scope.row.isEnable">
                <el-button type="info" size="mini" icon="el-icon-minus" circle @click="handleCancel(scope.$index, scope.row)"></el-button>

              </el-tooltip>

              <el-tooltip content="编辑" v-if="!scope.row.isEnable">
                  <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)"></el-button>

              </el-tooltip>
              <el-tooltip content="删除" v-if="mode == 'create'">
                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>

              </el-tooltip>
            </template>
        </el-table-column>
        </el-table>
      </div>

      <div style="height: 50px;line-height: 50px;margin-top:10px;text-align: center;">
        <el-button size="medium"  @click="cancel">取消</el-button>
        <el-button type="primary" size="medium"  @click="save">保存</el-button>
      </div>
        <AddProduct :diaVisible="isAddProdVisible" :selectData="listData" v-if="isAddProdVisible" @close="close" @confirm="confirm"></AddProduct>
    </div>
</template>
<script>
import AddProduct from '@/components/AddProduct';
import { addUptSalesOrder,batchDelSalesOrder,queryAllSalesOrder,delSalesOrder} from '@/api/business';
export default {
    name:'createGoods',
    props:['mode','editRow'],
    components:{AddProduct},
    data(){
        return {
            isAddProdVisible:false,
            orderForm:{
                salesOrderCode:'',
                contractCode:'',
                customerName:'',
            },
            loading:false,
            listData:[

            ],
            orderFormRule:{
                contractCode: [{
                    required: true,
                    message: "请输入合同编号",
                    trigger: "blur",
                },] ,
                customerName: [{
                    required: true,
                    message: "请输入客户名称",
                    trigger: "blur",
                },]
            },
            sourceList:[{
              label:'自制',
              value:'0'
            },{
              label:'外购',
              value:'1'
            },{
              label:'委外',
              value:'2'
            }],
            userData:{},
            planNum:0,
            planTime:[],

        }
    },
    created(){
      var userData = window.localStorage.getItem('userdata');
      if(userData){
        this.userData = JSON.parse(userData);
      }
      if(this.mode == 'create'){
        this.orderForm = {
          salesOrderCode:'',
          contractCode:'',
          customerName:'',
        };
        this.listData = [];
        this.planNum=0;
        this.planTime=[];
      }else{
      console.log(this.editRow);
        this.orderForm = JSON.parse(JSON.stringify(this.editRow));
        var planStartTime = !this.orderForm.planStartTime  ?"":this.orderForm.planStartTime;
        var planEndTime = !this.orderForm.planEndTime ? "" :this.orderForm.planEndTime;
        // this.orderForm.planTime = [planStartTime,planEndTime];
        this.orderForm.productInfo = {
          productCode:this.orderForm.productInfo?this.orderForm.productInfo.productCode:'',
          productName:this.orderForm.productInfo?this.orderForm.productInfo.productName:'',
        }
        this.listData = this.orderForm.productList;

      }

    },
    methods:{
      productFormat(val){
        var res = this.sourceList.filter(function(item){
          return item.value == val.source
        })
        if(res && res.length!=0){
          return res[0].label
        }
      },
        /**
         * 返回上一级
         */
        goBack(){
            this.$emit("goBack");
        },
        handleSave(index,row){
          console.log(this.planTime)
          row['planNum'] = this.planNum;
          row['planTime'] = this.planTime;
          this.listData[index].planStartTime = this.planTime[0]
          this.listData[index].planEndTime = this.planTime[1]
          row['isEnable'] = false;
          this.listData = JSON.parse(JSON.stringify(this.listData));

        },
        handleCancel(index,row){
          row['isEnable'] = false;
          this.listData = JSON.parse(JSON.stringify(this.listData));

        },
        handleEdit(index,row){
          this.planNum = row['planNum'];
          this.planTime = row['planStartTime'] && row['planEndTime']? [row['planStartTime'],row['planEndTime']]:[];
          row['isEnable'] = true;
          this.listData = JSON.parse(JSON.stringify(this.listData));
        },
        handleDelete(index,row){
          this.listData.splice(index,1);
        },
        addProduct(){
            this.isAddProdVisible = true;
        },
        close(){
            this.isAddProdVisible = false;
        },
        confirm(val){
          if(val && val != null){
            for(let i = 0;i<val.length;i++){
              let index = this.listData.findIndex(p => p._id == val[i]._id);
              if(index == -1){
                this.listData.push(val[i]);
              }else{
                this.listData[index] = val[i];
              }
            }
          }

        },
        save(){

          this.$refs.orderForm.validate((valid) => {
            if(valid){
              var data = JSON.parse(JSON.stringify(this.orderForm));
              data.productList = this.listData;
              data.factoryId = this.userData.factoryId;
              data.creater = this.userData.name + '(' + this.userData.account+')';
              this.loading = true;
              addUptSalesOrder(data).then(res=>{
                this.loading = false;
                if(res.code == 200){
                  this.$message.success('保存成功');
                  this.$emit('done',{type:'save'});
                }
              }).catch(()=>{
                this.loading = false;
              })
            }
          });

        },
        cancel(){
          this.$emit('done',{type:'cancel'});
        },
    },

}
</script>
<style scoped>
    .order-form{
        margin-top: 15px;
    }
    .tbl-btn{
        width: 100%;
        height: 50px;
        line-height: 50px;

    }
    .tbl-btn .tbl-btn-right{
        text-align: right;
    }
    .txt-overflow{
        text-overflow:ellipsis;
        white-space:nowrap;
    }


</style>



// WEBPACK FOOTER //
// src/views/goods/newGoods.vue